module.exports = __webpack_public_path__ + "static/media/new-tab.40807eb9.svg";